export default{
    api: {
        // 开发
        // Base_URL: 'http://192.168.8.15:8006/api/dealers/v1.0',//接口请求路径
        // OA_URL: 'https://oa.mxcae.com:9300/',//退出登录返回oa系统地址
        // 正式
        Base_URL: 'http://cloud.mxcae.com/api/dealers/v1.0/', //接口请求路径
        OA_URL: 'https://oa.mxcae.com:9300/',//退出登录返回oa系统地址
    },
}